import content from "app-content";
import PropTypes from "prop-types";
import CommonNoItems from "../../common/NoItems";
import Icon from "../../common/Icon";
import StartShoppingButton from "../../common/StartShoppingButton";
import SignInButton from "../../../containers/common/SignInButton";
import styles from "./index.css";

const NoItems = ({ isAuthenticated }) =>
  isAuthenticated ? (
    <CommonNoItems
      Icon={() => <Icon icon={"save-for-later"} className={styles.icon} />}
      title={content.saved_items_no_items}
      titleStyle={styles.title}
      messages={[
        content.saved_items_recognised_text_prompt,
        content.saved_items_recognised_text_sync
      ]}
      messagesStyle={styles.recognisedMessages}
      Button={StartShoppingButton}
    />
  ) : (
    <CommonNoItems
      Icon={() => <Icon icon={"sign-in-to-save"} className={styles.icon} />}
      title={content.saved_items_no_items}
      titleStyle={styles.title}
      messages={[content.saved_items_unrecognised_text]}
      messagesStyle={styles.unrecognisedMessages}
      Button={SignInButton}
    />
  );

NoItems.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired
};

export default NoItems;
